// react
// dependencies
import { List, Map } from "immutable";
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Status from "../../../../../containers/TaskRunner/components/Status";

import PropTypes from "../../../../../lib/prop-types";

// style
import css from "./style.module.scss";

class Job extends React.PureComponent {
	static propTypes = {
		job: PropTypes.instanceOf(Map).isRequired,
	};

	state = {
		showErrors: false,
	};

	toggleErrorsList = () => {
		this.setState({ showErrors: !this.state.showErrors });
	};

	render() {
		const { job } = this.props;
		const { showErrors } = this.state;

		const ermahgerds = job.get("errors", List());
		const isRunning = job.get("finished") === false && job.get("started") === true;

		// config
		let jobClass = "";
		let statusType = "idle";

		// config logic
		if (ermahgerds.size > 0) {
			statusType = "error";
			jobClass = css.hasError;
		} else if (isRunning) {
			statusType = "running";
			jobClass = css.isRunning;
		}

		return (
			<div className={`${css.Job} ${jobClass}`}>
				<div>
					<Status>{statusType}</Status>
					<div className={css.label}>{job.get("title", "")}</div>

					{ermahgerds.size > 0 ? (
						<div className={css.Errors}>
							{showErrors ? null : (
								<div className={css.errorTitle}>
									<div onClick={this.toggleErrorsList} className={css.titleSpan}>
										<span>{`There ${
											ermahgerds.size === 1 ? "is 1 error" : `are ${ermahgerds.size} errors`
										}`}</span>
										<FontAwesomeIcon
											className={css.toggleCaret}
											icon={["far", "caret-circle-down"]}
										/>
									</div>
								</div>
							)}

							{showErrors ? (
								<div className={css.errorsList}>
									{ermahgerds.map((error) => (
										<div key={error.get("id")} className={css.errorItem}>
											{error.get("message", "")}
										</div>
									))}
								</div>
							) : null}

							{showErrors ? (
								<div className={css.errorsListHide}>
									<div className={css.hideButton} onClick={this.toggleErrorsList}>
										<span>Hide Errors</span>
										<FontAwesomeIcon
											className={css.toggleCaret}
											icon={["far", "caret-circle-up"]}
										/>
									</div>
								</div>
							) : null}
						</div>
					) : null}
				</div>
			</div>
		);
	}
}

export default Job;
